export default __webpack_public_path__ + "static/media/Forest Random NPCs 2-1710417014814.ecfc9e70.PNG";